import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';
import { CacheService } from '../cache.service';
import { OrganizationDataResult } from 'src/app/key-cabinet/models/organization/organization-data-result.model';
import { Observable, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationDataService extends BaseService {
  private readonly urlPrefix = `${environment.keyAutomate.urlPrefix}/organization`;

  constructor(http: HttpClient, private cacheService: CacheService) {
    super(http);
  }

  getOrganizationData(): Observable<OrganizationDataResult> {
    return this.cacheService
      .get(
        `${this.constructor.name}_${this.getOrganizationData.name}`,
        `noversion`,
        this.get<OrganizationDataResult>(`${this.urlPrefix}/data`),
        []
      )
      .pipe(filter((d) => !!d));
  }
}
